module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comp-font-tip"
  }, [(this.text) ? _c('span', [_vm._v(_vm._s(_vm.text))]) : _vm._e(), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "placement": "right-start"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, _vm._l((_vm.tips), function(item) {
    return _c('p', {
      staticClass: "tip"
    }, [_vm._v("\n        " + _vm._s(item) + "\n      ")])
  })), _vm._v(" "), _c('i', {
    class: _vm.iconClass
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c6f115c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui/FontTip/FontTip.vue
// module id = 108
// module chunks = 0